import { render } from "./ClosingBalances.vue?vue&type=template&id=67facab8"
import script from "./ClosingBalances.vue?vue&type=script&lang=js"
export * from "./ClosingBalances.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__